<ion-row class="list-wrapper-background">
  <div class="jackpot-items">
    <ion-item lines="none" class="total-list-container">
      <ion-grid class="ion-no-padding splitter-line">
        <ion-row>
          <swiper class="store-slider-trigger" [config]="storeSliderOptions2" #slider
            (swiper)="setSwiperInstance($event)">
            @for (item of promotions; track item; let i = $index) {
            <ng-template swiperSlide>
              <div class="jpt-banner" [ngClass]="{'card-gray':cardOfferDisabled(i)}"
                [ngStyle]="{'background': item.background}">
                <div class="overlay-2 single-overlay">
                  <div class="adjusted-column-sizes">
                    <div class="column-70">
                      <div class="card-title">
                        <h5>{{item.jackpot_value}}</h5>
                        <p [innerHTML]="item.content.description" class="card-desc"></p>
                      </div>
                      <ion-button class="card-cta" (click)="onCtaClick(item, i)" [disabled]="cardOfferDisabled(i)">
                        <p [innerHTML]="item.content.cta_label"></p>
                      </ion-button>
                    </div>
                    <div class="column-40">
                      <p class="cardTimer">
                        {{item.content.expiry_label}}<br>{{expiryMinutes}}:{{seconds}}
                      </p>
                      <div class="image-wrapper">
                        <img alt="Lottery icon" src="{{item.image_url}}" />
                      </div>
                    </div>
                  </div>
                  <!-- Processing Indicator -->
                  @if (processingStates[i]) {
                  <div class="processing-overlay">
                    <div class="spinner"></div>
                    <p>Processing...</p>
                  </div>
                  }
                </div>
              </div>
            </ng-template>
            }
          </swiper>
          <ion-row class="my-custom-pager">
            <ion-col sizeSm="4" sizeLg="4" class="pager-2">
              <button (click)="prev()" class="nav-prev-icon-euro">
                <ion-icon name="chevron-back-outline"></ion-icon>
              </button>
            </ion-col>
            <ion-col sizeSm="2" sizeLg="4" class="pager-2">
              <div class="swiper-pagination-2"></div>
            </ion-col>
            <ion-col sizeSm="4" sizeLg="4" class="pager-2">
              <button (click)="next()" class="nav-next-icon-euro">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </button>
            </ion-col>
          </ion-row>
        </ion-row>
      </ion-grid>
    </ion-item>
  </div>
</ion-row>
